import React from 'react';
import heroImage from '../assets/tinkerlabs__web__hero.webp';
import logoImage from '../assets/tinkerlabs__web__logo.webp';
import { ChevronDown } from 'lucide-react';

const Hero = ({toSection,section}) => {
    
  return (
    <div id={section} className="relative h-auto">
      {/* Hero image section */}
      <div className="h-[500px] relative">
        <img 
          src={heroImage}
          alt="Children in lab coats" 
          className="w-full h-full object-cover"
        />
        
        {/* Wave with logo */}
        <div className="absolute bottom-0 left-0 right-0">
          {/* Wave SVG */}
          <svg 
            viewBox="0 0 1440 300" 
            className="w-full"
            style={{ 
              display: 'block',
              height: '150px'
            }}
            preserveAspectRatio="none"
          >
          {/*   <path 
              fill="white" 
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,200L1392,200C1344,200,1248,200,1152,200C1056,200,960,200,864,200C768,200,672,200,576,200C480,200,384,200,288,200C192,200,96,200,48,200L0,200Z"
            /> */}
          </svg>
          
          {/* Centered logo */}
          <div className="">
            <div className="">
              <img 
                src={logoImage}
                alt="Tinker Labs" 
                className="logoTl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Content section */}
      <div className="bg-white pt-20 pb-16">
        <div className="container mx-auto px-4">
          <div className="mx-auto text-center">
            <h1 className="font-['Grandstander'] text-[#002147] text-5xl font-extrabold mb-4 leading-tight">
              Inspiring EUREKA Moments
            </h1>
            <p className="font-['Lexend'] text-[#66c3d0] text-xl mb-8 leading-relaxed">
              Become a Tinker Labs franchisee and lead the charge in
              children's education of the 21st century
            </p>
            
            <button onClick={()=>toSection("needforsteem")} className="bg-[#F18917] text-white px-8 py-3 rounded-[50px] font-['Lexend'] font-semibold text-lg transition-all flex items-center mx-auto">
              Learn More
              <ChevronDown className="ml-2 w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;